import { builder } from '@builder.io/react'

export async function getAllBuilderGreetingCardDesigns() {
    return await builder.getAll('greeting-card-designs', {})
}

export default getAllBuilderGreetingCardDesigns
